import SectionTitle from 'components/global/SectionTitle'
import { Col, Row } from 'components/grid'
import StarterKit from 'components/intervention/StarterKit'
import { graphql, useStaticQuery } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

interface Props {
	showFrameworks?: boolean
}

export default function IRLAStarterKits({ showFrameworks }: Props) {
	const { irlaElem, irlaMiddle, irlaHigh } = useStaticQuery<StarterKitQuery>(query)

	const gradeSort = (a: StarterKitQueryNode, b: StarterKitQueryNode) => {
		if (a.node.grade === 'K') return -1
		if (b.node.grade === 'K') return 1
		return parseInt(a.node.grade) - parseInt(b.node.grade)
	}

	return (
		<>
			<SectionTitle title="IRLA Starter Kits" />
			<Row>
				<Col>
					<Tabs selectedTabClassName="bg-slate-50 font-bold">
						<TabList className="flex flex-wrap">
							<Tab className="flex-grow cursor-pointer rounded-t border-t border-l border-r border-b-4 bg-white p-3 text-center hover:bg-slate-50">Elementary</Tab>
							<Tab className="flex-grow cursor-pointer rounded-t border-t border-l border-r border-b-4 bg-white p-3 text-center hover:bg-slate-50">Middle School</Tab>
							<Tab className="flex-grow cursor-pointer rounded-t border-t border-l border-r border-b-4 bg-white p-3 text-center hover:bg-slate-50">High School</Tab>
						</TabList>
						<TabPanel>
							<div className="mt-6 px-6">
								<Tabs selectedTabClassName="bg-slate-50 font-bold">
									<TabList className="flex flex-wrap">
										{irlaElem.edges.sort(gradeSort).map(({ node }) => {
											return (
												<Tab
													key={node.name}
													className="flex-grow cursor-pointer rounded-t border-t border-l border-r border-b-4 bg-white p-3 text-center hover:bg-slate-50"
												>
													{node.grade}
												</Tab>
											)
										})}
									</TabList>

									{irlaElem.edges.sort(gradeSort).map((e) => {
										return (
											<TabPanel key={e.node.id}>
												<StarterKit data={e} type="irla" showFrameworks={showFrameworks} />
											</TabPanel>
										)
									})}
								</Tabs>
							</div>
						</TabPanel>
						<TabPanel>
							<div className="mt-6 px-6">
								<Tabs selectedTabClassName="bg-slate-50 font-bold">
									<TabList className="flex flex-wrap">
										{irlaMiddle.edges.sort(gradeSort).map(({ node }) => {
											return (
												<Tab
													key={node.name}
													className="flex-grow cursor-pointer rounded-t border-t border-l border-r border-b-4 bg-white p-3 text-center hover:bg-slate-50"
												>
													{node.grade}
												</Tab>
											)
										})}
									</TabList>

									{irlaMiddle.edges.sort(gradeSort).map((e) => {
										return (
											<TabPanel key={e.node.id}>
												<StarterKit data={e} type="irla" showFrameworks={showFrameworks} />
											</TabPanel>
										)
									})}
								</Tabs>
							</div>
						</TabPanel>
						<TabPanel>
							<div className="mt-6 px-6">
								<Tabs selectedTabClassName="bg-slate-50 font-bold">
									<TabList className="flex flex-wrap">
										{irlaHigh.edges.sort(gradeSort).map(({ node }) => {
											return (
												<Tab
													key={node.name}
													className="flex-grow cursor-pointer rounded-t border-t border-l border-r border-b-4 bg-white p-3 text-center hover:bg-slate-50"
												>
													{node.grade}
												</Tab>
											)
										})}
									</TabList>

									{irlaHigh.edges.sort(gradeSort).map((e) => {
										return (
											<TabPanel key={e.node.id}>
												<StarterKit data={e} type="irla" showFrameworks={showFrameworks} />
											</TabPanel>
										)
									})}
								</Tabs>
							</div>
						</TabPanel>
					</Tabs>
				</Col>
			</Row>
		</>
	)
}

export interface StarterKitQueryNode {
	node: {
		id: string
		name: string
		grade: string
		skillsCards: {
			id: string
			title: string
			gatsbyImageData: IGatsbyImageData
		}
		baskets: {
			id: string
			title: string
			gatsbyImageData: IGatsbyImageData
		}[]
	}
}

export interface StarterKitQueryEdge {
	edges: StarterKitQueryNode[]
}

interface StarterKitQuery {
	irlaElem: StarterKitQueryEdge
	irlaMiddle: StarterKitQueryEdge
	irlaHigh: StarterKitQueryEdge
	enilElem: StarterKitQueryEdge
}

const query = graphql`
	query {
		irlaElem: allContentfulIrlaStarterKit(filter: { type: { eq: "IRLA" }, gradeLevel: { eq: "Elementary" } }) {
			edges {
				node {
					...irlaStarterKit
				}
			}
		}
		irlaMiddle: allContentfulIrlaStarterKit(filter: { type: { eq: "IRLA" }, gradeLevel: { eq: "Middle School" } }) {
			edges {
				node {
					...irlaStarterKit
				}
			}
		}
		irlaHigh: allContentfulIrlaStarterKit(filter: { type: { eq: "IRLA" }, gradeLevel: { eq: "High School" } }) {
			edges {
				node {
					...irlaStarterKit
				}
			}
		}
		enilElem: allContentfulIrlaStarterKit(filter: { type: { eq: "ENIL" }, gradeLevel: { eq: "Elementary" } }) {
			edges {
				node {
					...irlaStarterKit
				}
			}
		}
	}
`
